{
    "NAME": "Linguagem de gerenciamento de licenças",
    "LicenseManagement_Action_Refresh": "Atualizar status da licença",
    "LicenseManagement_Action_Reload": "Recarregar licenças",
    "LicenseManagement_Reload_Confirm": "Recarregar dados de licença?",
    "LicenseManagement_Reload_Success": "Dados da licença recarregados.",
    "LicenseManagement_Status_Title": "Situação atual da licença",
    "LicenseManagement_Status_Empty": "Não há informações disponíveis sobre o status da licença.",
    "LicenseManagement_Status_LimitedAccess": "Apenas o status geral da licença está disponível para o escopo atual.",
    "LicenseManagement_Status_Entry": "Entrada",
    "LicenseManagement_Status_Value": "Valor",
    "LicenseManagement_Status_Usage": "Uso",
    "LicenseManagement_Status_Status": "Status",
    "LicenseManagement_Profiles_Title": "Perfis de Servidor de Telefonia",
    "LicenseManagement_Profiles_Empty": "Não há perfis de servidor de telefonia disponíveis.",
    "LicenseManagement_Billing_Title": "Relatórios de faturamento",
    "LicenseManagement_Billing_Filters": "Filtros",
    "LicenseManagement_Billing_Advanced": "Opções avançadas",
    "LicenseManagement_Billing_Actions": "Ações",
    "LicenseManagement_Billing_OnlyBillable": "Somente configuração faturável",
    "LicenseManagement_Billing_SystemWideUsers": "Incluir usuários de todo o sistema",
    "LicenseManagement_Billing_BillingExcluded": "Incluir configurações excluídas da cobrança",
    "LicenseManagement_Billing_Simulation": "Inclui sistemas telefônicos de simulação",
    "LicenseManagement_Billing_Summary": "Resumo de Faturamento",
    "LicenseManagement_Billing_Cdr": "CDRs de faturamento",
    "LicenseManagement_Billing_SummaryConfirm": "Gerar o relatório de resumo de faturamento?",
    "LicenseManagement_Billing_CdrConfirm": "Gerar o relatório CDR de faturamento?",
    "LicenseManagement_Diagnostic": "Relatório de diagnóstico",
    "LicenseManagement_Diagnostic_Confirm": "Gerar o relatório de diagnóstico da licença?",
    "LicenseManagement_Filter_Cme": "Educação Médica Continuada",
    "LicenseManagement_Filter_TelSys": "Servidor de telefonia",
    "LicenseManagement_Filter_Partition": "Partição"
}